import { render, staticRenderFns } from "./accessModal.vue?vue&type=template&id=61c3b146&"
import script from "./accessModal.vue?vue&type=script&lang=js&"
export * from "./accessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports